import { render, staticRenderFns } from "./AddToProductSetButton.vue?vue&type=template&id=3fb3968d&scoped=true"
import script from "./AddToProductSetButton.vue?vue&type=script&lang=js"
export * from "./AddToProductSetButton.vue?vue&type=script&lang=js"
import style0 from "./AddToProductSetButton.vue?vue&type=style&index=0&id=3fb3968d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3968d",
  null
  
)

export default component.exports